//
// FavoritesManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./Voucher";
import "../models/media/particles/FavoriteState";
import "../models/local/Folder";

var FavoritesManager = createModule("transport_FavoritesManager", [50363,50137], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        removeFavorites: [1,[1],1],
        addFavoriteGroup: [1,7,1],
        getFavorites: [1,1],
        renameFavoriteGroup: [1,7,1],
        addFavorites: [1,[1],1],
        updateFavoriteReportStatus: [1],
        isValidReport: [2,1],
        getRootFavoritesFolder: [1],
        getFavoriteState: [4,1],
        addFavorite: [1,1,1],
        isRootFavorite: [2,1],
        isFavoriteInFolder: [2,1,1],
        removeFavoriteGroup: [1,1],
        removeFavorite: [1,1,1],
        isValidGroupName: [2,7],
        isValidFolder: [2,1],
    },
    {
        isFavorite: [2,1],
    },
    ,
]);
export default FavoritesManager;
